// extracted by mini-css-extract-plugin
export default {"footer":"components-payment-modal-edit-billing-details-module__footer"};